import store from '../store';
import Constants from '../config/constants';
import {serviceGetContact} from "../services/Contact.service";


export const FETCH_INIT = 'FETCH_INIT_CONTACT_LIST';
export const FETCHED = 'FETCHED_CONTACT_LIST';
export const FETCHED_FAIL = 'FETCHED_FAIL_CONTACT_LIST';
export const FETCHED_FILTER = 'FETCHED_FILTER_CONTACT_LIST';
export const FETCH_NEXT = 'FETCH_NEXT_CONTACT_LIST';
export const FILTER = 'FILTER_CONTACT_LIST';
export const RESET_FILTER = 'RESET_FILTER_CONTACT_LIST';
export const SET_SORTING = 'SET_SORTING_CONTACT_LIST';
export const SET_FILTER = 'SET_FILTER_CONTACT_LIST';
export const SET_PAGE = 'SET_PAGE_CONTACT_LIST';
export const CHANGE_PAGE = 'CHANGE_PAGE_CONTACT_LIST';
export const CHANGE_STATUS= 'CHANGE_STATE_CONTACT_LIST';
export const SET_SERVER_PAGE = 'SET_SERVER_PAGE_CONTACT_LIST';
export const CREATE_DATA = 'CREATE_CONTACT_LIST';
export const UPDATE_DATA = 'UPDATE_CONTACT_LIST';
export const DELETE_ITEM = 'DELETE_CONTACT_LIST';

export function actionFetchContact(index = 1, sorting = {}, filter = {}) {
    const request = serviceGetContact({ index, row: sorting.row, order: sorting.order, ...filter });
    return (dispatch) => {
        dispatch({type: FETCH_INIT, payload: null});
        request.then((data) => {
            dispatch({type: SET_FILTER, payload: filter});
            dispatch({type: SET_SORTING, payload: sorting});
            if (!data.error) {
                dispatch({type: FETCHED, payload: { data: data.data, page: index }});
                dispatch({ type: SET_SERVER_PAGE, payload: index });
                if (index == 1) {
                    dispatch({type: CHANGE_PAGE, payload: index - 1});
                }
            } else {
                dispatch({type: FETCHED_FAIL, payload: null});
            }
        });
    };
}



export function actionChangePageContactRequests(page) {
    return (dispatch) => {
        dispatch({type: CHANGE_PAGE, payload: page})
    }
}

export function actionFilterContactRequests(value) {
    const request = null;////serviceFetchProviderRequests(value);
    return (dispatch) => {
        dispatch({type: FETCH_INIT, payload: null});
        request.then((data) => {
            dispatch({type: FILTER, payload: data});
            dispatch({type: FETCHED, payload: null});//dispatch function
        });
    };
}



export function actionSetPageContactRequests(page) {
    const stateData = store.getState().whatsapp_contact_list;
    const currentPage = stateData.currentPage;
    const totalLength = stateData.all.length;
    const sortingData = stateData.sorting_data;
    const query = stateData.query;
    const queryData = stateData.query_data;
    const serverPage = stateData.serverPage;

    if (totalLength <= ((page + 1) * Constants.PAGE_VALUE)) {
        store.dispatch(actionFetchContact(serverPage + 1, sortingData, {query, query_data: queryData}));
        // this.props.fetchNextUsers(this.props.serverPage + 1, this.props.sorting_data.row, this.props.sorting_data.order, { query: this.props.query, query_data: this.props.query_data });
    }
    return {
        type: CHANGE_PAGE,
        payload: page,
    };
}
